import { useState, useCallback } from 'react';
import quarkusApi from '../../../../api/quarkusApi';

export function useSaveAnamnesisV2() {
  const [isSaving, setSaving] = useState(false);

  const save = useCallback((patientId, anamnesisId, anamnesis) => {
    setSaving(true);
    const authHeader = { headers: { Authorization: sessionStorage.getItem('token') } };
    const request = anamnesisId
      ? quarkusApi.put(`/v2/anamnesis/${anamnesisId}`, anamnesis, authHeader)
      : quarkusApi.post(`/v2/anamnesis/patient/${patientId}`, anamnesis, authHeader);
    return request.finally(() => setSaving(false));
  }, []);

  return { save, isSaving };
}
